import { ASSETS } from "@/data/site";

export const PLAN_CONTENT = {
  detox: {
    name: "Detoxplan",
    lookup_key: "plan_detox",
    price: "kr 399",
    signature: "Heal din egen kropp frisk og sterk.",
    kicker: "Detoxplan",
    title: ["Detox handler ikke om en hurtig kur.", "Det handler om å rydde veien for kroppen."],
    image: ASSETS.mockDetox,
    blocks: [
      { type: "p", text: "Vi lever i en verden der kroppen hver eneste dag må håndtere mer enn den egentlig er bygget for: ultraprosessert mat, sprøytemidler, miljøgifter, alkohol, stress, søvnmangel og en livsstil som ofte trekker oss stadig lenger bort fra det naturlige." },
      { type: "p", text: "Kroppen arbeider allerede kontinuerlig med å bryte ned, omdanne og skille ut avfallsstoffer. Men jeg mener vi kan gjøre langt mer for å støtte disse prosessene – gjennom maten vi spiser, det vi velger bort, og de små rutinene vi gjentar hver dag. Vi har aldri fått denne kunnskapen om kroppen, og helsen vår har derfor blitt dårligere i takt med offentlige anbefalinger." },
      { type: "p", text: "Derfor har jeg utviklet detoxplaner som gjør det enklere å rydde opp, redusere belastningen og bygge kroppen opp igjen innenfra." },
      { type: "p", text: "Planene inneholder rutiner for blant annet ren mat, faste, fordøyelse, lever- og tarmstøtte, svette, mineraler, urter og bevisste livsstilsvalg. Du finner også egne opplegg og informasjon om parasittrens, hvordan det brukes innenfor alternative helseretninger, hvilke tegn man bør være oppmerksom på, og hvordan man går frem på en mest mulig trygg og gjennomtenkt måte." },
      { type: "p", text: "Dette handler ikke om ekstremisme eller om å gjøre alt perfekt. Det handler om å begynne å forstå hva kroppen forsøker å fortelle deg, og gi den bedre arbeidsbetingelser." },
      { type: "p", text: "Når vi fjerner noe av det som belaster oss og samtidig tilfører ekte næring, ro, væske, bevegelse og søvn, gir vi kroppens naturlige systemer bedre støtte." },
      { type: "p", text: "Jeg har samlet kunnskapen, verktøyene og rutinene på ett sted, slik at du slipper å lete deg gjennom hundrevis av motstridende råd." },
      { type: "pull", text: "Du trenger ikke gjøre alt på én gang. Men du må være villig til å begynne." },
    ],
    closing: [],
  },

  livsstil: {
    name: "Livsstilsplan",
    lookup_key: "plan_livsstil",
    price: "kr 299",
    kicker: "Livsstilsplan · inkluderer kosthold og barn",
    title: ["Helse skapes ikke av én enkelt vane.", "Den skapes av alt du gjør hver dag."],
    image: ASSETS.mockLivsstil,
    blocks: [
      { type: "p", text: "De fleste leter etter den ene løsningen. Den perfekte dietten. Det riktige kosttilskuddet. Den neste helsehacken." },
      { type: "p", text: "Men sannheten er at kroppen vår formes av summen av valgene vi tar, dag etter dag, år etter år." },
      { type: "p", text: "Hva vi spiser. Hvordan vi beveger oss. Hvordan vi sover. Hvordan vi håndterer stress. Hva vi puster inn. Hva vi smører på huden. Hvem vi omgir oss med. Hvor mye dagslys vi får. Hvor mye tid vi tilbringer foran en skjerm. Alt påvirker kroppen mer enn vi ofte er klar over." },
      { type: "p", text: "Livsstilsplanen min handler derfor ikke bare om kosthold. Det er masse tips og råd som handler om å bygge en kropp og et liv som gir deg mer energi, bedre helse og større motstandskraft." },
      { type: "p", text: "Du får konkrete verktøy og enkle rutiner innen blant annet ernæring, søvn, stressmestring, bevegelse, faste, dagslys, pust, varmeterapi/sauna, skjermvaner, miljøgifter og andre livsstilsfaktorer som kan påvirke hvordan kroppen fungerer." },
      { type: "lead", text: "Målet er ikke å gjøre livet komplisert. Målet er å gjøre de viktigste tingene enkle." },
      { type: "p", text: "Jeg tror ikke god helse handler om perfeksjon. Den handler om bevisste valg – gjort ofte nok til at de blir en naturlig del av hverdagen." },
      { type: "p", text: "Derfor er planene laget for vanlige mennesker med en travel hverdag. Du trenger ikke snu livet opp ned over natten. Du trenger bare å vite hvilke grep som gir størst effekt, og ta ett steg av gangen." },
      { type: "p", text: "Små endringer, gjentatt hver dag, kan over tid skape en helt ny kropp, mer energi og en bedre livskvalitet." },
      { type: "p", text: "Pakken inneholder også egne råd, oppskrifter og rutiner for barn og familie – slik at hele husstanden kan bygge sunne vaner sammen. Kosthold, livsstil og barn er samlet i én komplett plan." },
      { type: "pull", text: "Du trenger ikke være perfekt. Du trenger bare å begynne." },
    ],
    closing: ["Lev mer bevisst.", "Bygg sterke vaner.", "Skap helse for livet."],
  },

  barn: {
    name: "Mat & livsstil for barn",
    lookup_key: "plan_livsstil",
    price: "kr 299",
    kicker: "Inkludert i Livsstilsplanen",
    title: ["Barna våre fortjener bedre.", "Og det er vårt ansvar å gi dem det."],
    image: ASSETS.mockKosthold,
    blocks: [
      { type: "p", text: "Vi elsker barna våre høyere enn noe annet. Likevel vokser de opp i et matsystem der ultraprosessert mat, sukker og kunstige tilsetningsstoffer har blitt normalen – både hjemme, i barnehagen, på skolen og i butikken." },
      { type: "lead", text: "Konsekvensene ser vi allerede." },
      { type: "p", text: "Barn blir sykere tidligere enn noen gang. Overvekt, insulinresistens, type 2-diabetes, fordøyelsesplager, allergier og konsentrasjonsutfordringer blir stadig vanligere. Etter min mening er dette ikke tilfeldig. Det er resultatet av en livsstil og et kosthold som har beveget seg stadig lenger bort fra det kroppen vår er skapt for." },
      { type: "p", text: "Jeg mener vi må slutte å senke standarden for hva vi gir barna våre. Vi trenger ikke mer ultraprosessert «barnemat». Vi trenger ekte mat. Ren mat. Og mindre komplisert mat." },
      { type: "p", text: "Derfor har jeg laget plansjer med masse tips og råd som gjør det enkelt å servere rene, næringsrike måltider basert på råvarer av høy kvalitet. Mat som bygger kroppen, støtter utviklingen og gir barna de beste forutsetningene for å vokse opp sterke og friske – hvor man kan bytte ut råvarer, uten at det går utover kosen." },
      { type: "p", text: "Planene inneholder flere enkle oppskrifter, frokoster, matpakker, middager, snacks og rutiner som gjør det lettere å velge ekte mat, også i en travel hverdag." },
      { type: "p", text: "Alt dette er inkludert i Livsstilsplanen – kosthold, livsstil og barn samlet i én komplett pakke." },
      { type: "pull", text: "For barna våre fortjener ikke det som er normen. De fortjener det som er best." },
    ],
    closing: ["Ekte mat.", "Sterke kropper.", "En friskere fremtid."],
  },

  booty: {
    name: "Booty & Hourglass",
    lookup_key: "plan_booty",
    price: "kr 499",
    signature: "Ja, det er lov å ville ha en fin rumpe!",
    kicker: "Booty & Hourglass · treningsprogram og matplaner for sterk kropp",
    title: ["Bygg en sterk,", "balansert kropp."],
    image: ASSETS.mockTrening,
    blocks: [
      { type: "p", text: "La oss bare kalle en spade for en spade." },
      { type: "p", text: "Mange av oss trener fordi vi vil være sterke, holde kroppen frisk og ha energi langt inn i alderdommen. Men vi kan vel også innrømme at en sterk, spretten rumpe, smalere midje og litt mer definerte skuldre ikke akkurat gjør noe. 😅" },
      { type: "p", text: "Det er nettopp derfor jeg har laget dette programmet – både til deg som vil trene hjemme, og til deg som vil trene på et senter." },
      { type: "p", text: "Du får mine favorittprogrammer for både treningssenter og hjemme, bygget rundt det mange kvinner faktisk ønsker å oppnå: mer rumpe og former, en sterk og stram overkropp, mindre fett – og en kropp som både SER og FØLES sterk." },
      { type: "lead", text: "Men dette handler om mer enn utseende." },
      { type: "p", text: "Jeg synes vi har fått en merkelig idé om at det er overfladisk å ville se bra ut, samtidig som vi snakker om selvkjærlighet og det å ta vare på oss selv. For meg henger alt sammen." },
      { type: "pull", text: "Kroppen er tross alt stedet sjelen din skal bo resten av dette livet. Da kan vi like gjerne ta godt vare på huset. 😉" },
      { type: "p", text: "Du får strukturerte treningsprogrammer, tydelige øvelser og en tilhørende matplan som lærer deg hvordan du spiser for å bygge muskler, få energi, restituere og faktisk få resultater av jobben du legger ned." },
      { type: "lead", text: "Ingen quick fix. Ingen mirakeløvelse. Men du VIL få resultater!" },
      { type: "p", text: "Bare det som faktisk fungerer, gjort lenge nok til at kroppen får tid til å svare." },
      { type: "pull", text: "Du kan manifestere drømmer, kjærlighet og abundance så mye du vil. Men rumpa? Den må du faktisk trene. 😅" },
      { type: "script", text: "Love, C" },
    ],
    closing: [],
  },

  kosttilskudd: {
    name: "Anbefalte kosttilskudd",
    lookup_key: "plan_kosttilskudd",
    free: true,
    price: "Gratis",
    signature: "Det jeg faktisk tar – og hvorfor.",
    kicker: "Anbefalte kosttilskudd · gratis guide",
    title: ["Kosttilskudd handler ikke om mer.", "Det handler om det riktige."],
    image: ASSETS.mockKosttilskudd,
    blocks: [
      { type: "p", text: "Jeg får ofte spørsmål om hvilke kosttilskudd jeg tar – og hvorfor. Derfor har jeg samlet hele rutinen min på ett sted, helt gratis, slik at du kan se nøyaktig hva jeg bruker og tankegangen bak hvert enkelt valg." },
      { type: "p", text: "Kosttilskudd skal aldri erstatte ekte mat, søvn, bevegelse og ro. Men riktig brukt kan de være verdifull støtte – spesielt i en hverdag der jorda er mer utarmet og maten mindre næringstett enn før." },
      { type: "lead", text: "Mindre hype. Mer kunnskap." },
      { type: "p", text: "Jeg deler hva jeg tar, hvorfor jeg tar det, og hva du bør være oppmerksom på når det gjelder kvalitet, dosering og timing. Målet er at du skal kunne ta informerte valg for din egen kropp." },
      { type: "pull", text: "Start med maten. Bruk tilskudd som støtte – ikke som en snarvei." },
    ],
    closing: ["Ekte næring først.", "Kloke tilskudd etterpå.", "Alltid på egne premisser."],
  },
};

export const PLAN_CARDS = [
  { title: "Detoxplan", desc: "Rens kroppen og heal deg selv frisk og sterk – på egne premisser.", img: ASSETS.mockDetox, to: "/plan/detox", price: "kr 399", lookup_key: "plan_detox" },
  { title: "Livsstilsplan", desc: "Kosthold, livsstil og barn samlet i én komplett pakke.", img: ASSETS.mockLivsstil, to: "/plan/livsstil", price: "kr 299", lookup_key: "plan_livsstil" },
  { title: "Booty & Hourglass", desc: "Treningsprogram og matplaner for sterk kropp.", img: ASSETS.mockTrening, to: "/plan/booty", price: "kr 499", lookup_key: "plan_booty" },
  { title: "Anbefalte kosttilskudd", desc: "Nøye utvalgte anbefalinger jeg stoler på – helt gratis.", img: ASSETS.mockKosttilskudd, to: "/plan/kosttilskudd", price: "Gratis", lookup_key: "plan_kosttilskudd", free: true },
];

// Structured pre-checkout facts shown on every plan detail page so the buyer
// knows exactly what they get, in what format and on what terms, before paying.
const _COMMON = {
  format: "Digital PDF – laster ned med en gang",
  compatibility: "Fungerer på mobil, nettbrett og PC (alle PDF-lesere)",
  delivery: "Umiddelbart etter betaling – på skjermen og på e-post",
  updates: "Gratis oppdateringer av gjeldende utgave",
  terms: "Digitalt innhold. Ved umiddelbar levering samtykker du til at angreretten bortfaller når nedlastingen starter.",
};

export const PLAN_DETAILS = {
  detox: {
    ...(_COMMON),
    length: "ca. 25 sider",
    contents: [
      "Ren mat, faste og fordøyelse",
      "Lever- og tarmstøtte",
      "Mineraler, urter og svette/sauna",
      "Eget opplegg og info om parasittrens",
      "Trygge, gjennomtenkte rutiner steg for steg",
    ],
  },
  livsstil: {
    ...(_COMMON),
    length: "ca. 16 sider",
    contents: [
      "Ernæring og komplett kostholdsplan",
      "Søvn, stressmestring og bevegelse",
      "Faste, dagslys, pust og varmeterapi/sauna",
      "Skjermvaner og miljøgifter",
      "Eget opplegg for barn og familie – inkludert",
    ],
  },
  barn: {
    ...(_COMMON),
    length: "Inkludert i Livsstilsplanen (ca. 16 sider)",
    contents: [
      "Oppskrifter: frokost, matpakker, middag og snacks",
      "Rutiner for rene, næringsrike måltider",
      "Tips til travle hverdager",
      "Del av Livsstilsplanen – kosthold, livsstil og barn samlet",
    ],
  },
  booty: {
    ...(_COMMON),
    length: "ca. 38 sider",
    contents: [
      "Komplett hjemmetreningsprogram",
      "Fokus på rumpe, kjerne og helkropp",
      "Tilhørende matplaner for styrke og restitusjon",
      "Følg i ditt eget tempo – hjemmefra",
    ],
  },
  kosttilskudd: {
    ...(_COMMON),
    length: "ca. 15 sider",
    delivery: "Umiddelbart – på skjermen og på e-post",
    terms: "Digitalt innhold, helt gratis. Du oppgir kun e-post for å motta nedlastingslenken.",
    contents: [
      "Kosttilskuddene jeg faktisk bruker",
      "Hvorfor jeg tar hvert enkelt – enkelt forklart",
      "Tanker om kvalitet, dosering og timing",
      "Rene, gjennomtenkte valg – uten hype",
    ],
  },
};

